import { Component } from '@angular/core';

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: [],
    standalone: false
})
export class DateRangeComponent {

}
